export default __webpack_public_path__ + "static/media/violation.63ccb534.png";